export default __webpack_public_path__ + "static/media/send-icon.35a77815.svg";